import { HomeContent } from "components/information-lister-pages/HomeContent";
import React from "react";
import { AutoLayout } from "layouts/AutoLayout";
import { withAdvertising } from "services/advertising";
import { getFiltersWithModels, withFiltersFromProps } from "services/filter";
import { useMediaContext } from "lib/media-query";
import {
    defaultSearchFilters,
    getListingsWithCounters,
    withSearchFromProps
} from "services/search";
import { StructuredData } from "components/StructuredData";
import { getContentfulEntries } from "services/contentful/client/contentfulClient";
import { mapIdToFields, resolveIncludes } from "lib/contentful";

export const PageComponent = ({ content = {} }) => {
    const mediaContext = useMediaContext();
    const isMobilePhone = mediaContext.isMobile || mediaContext.isMobilePlus;
    return (
        <>
            <AutoLayout
                title={content?.titleSeo}
                description={content?.metaDescriptionSeo}
                pageName="home"
                pageType="home"
                path="/"
                googleSearchConsole="sUw1kNICqQpNAP3yFF2grOp9GsoWs1ev4_chRs0rnFA"
                faceBookPixel="00m3hutagwui3g2ac3wt6eg6o9slv7"
            >
                <HomeContent content={content} />
            </AutoLayout>
            <StructuredData type="WebSite" />
        </>
    );
};

export const HomePage = withAdvertising(
    "home",
    withFiltersFromProps(
        withSearchFromProps(({ content, ...rest }) => {
            return <PageComponent content={content} {...rest} />;
        })
    )
);

HomePage.displayName = "HomePage";

HomePage.getInitialProps = async ({ asPath }) => {
    const path = asPath.split("?").shift();

    const params = {
        "contentType": "dynamicInformationPage",
        "fields.path": path,
        "include": 3
    };

    const searchParams = { pageSize: 8 };

    const [contentResults, listingsResults, filtersResults] = await Promise.allSettled([
        getContentfulEntries(params)
            .then((data) => mapIdToFields(data))
            .then(({ items, includes }) => resolveIncludes(items, includes))
            .then((items) => items?.[0]?.fields),

        getListingsWithCounters(defaultSearchFilters, searchParams).then(
            ({ total, hits, aggregations }) => ({
                results: { hits },
                counts: {
                    ...aggregations,
                    total
                }
            })
        ),

        getFiltersWithModels()
    ]);

    // if listings request fails for whatever reason let's log the error
    if (listingsResults.reason) {
        console.error(
            JSON.stringify({
                errorType: `listing fetch error: ${listingsResults.reason}`
            })
        );
    }
    // if filters request fails for whatever reason let's log the error
    if (filtersResults.reason) {
        console.error(
            JSON.stringify({
                errorType: `listing fetch error: ${filtersResults.reason}`
            })
        );
    }

    const filters = filtersResults.status === "fulfilled" ? filtersResults.value : {};
    const listings = listingsResults.status === "fulfilled" ? listingsResults.value : undefined;
    const content = contentResults.status === "fulfilled" ? contentResults.value : undefined;

    return {
        results: listings?.results ?? {},
        counts: listings?.counts ?? {},
        filters: filters ?? {},
        content
    };
};

export default HomePage;
